import React, { useState } from "react";
import { Grid, IconButton, TextField } from "@material-ui/core";
import { InlineEditWrapper } from "../add-review-stage/add-review-stage.styles";
import { SaveOutlined } from "@material-ui/icons";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import usePermissions from "../../../hooks/usePermissions";
import { EditReviewStageProps } from "./edit-review-stage-name.props";

export const EditReviewStageName: React.FC<EditReviewStageProps> = ({ value, saveStageName }) => {
  const [editMode, setEditMode] = useState(false);
  const [stageName, setStageName] = useState(value);
  const userPermissions = usePermissions();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setStageName(e.target.value);
  };
  const toggleEditMode = () => {
    setEditMode(!editMode);
  };
  const handleSave = () => {
    saveStageName(stageName);
    setEditMode(!editMode);
  };
  return (
    <Grid item sm={6} md={4} lg={2}>
      <InlineEditWrapper>
        {editMode ? (
          <>
            <TextField
              id="newReviewer-label"
              label="Step Name"
              type="text"
              value={stageName}
              className="underlined"
              onChange={handleChange}
              autoComplete="off"
              required
            />
            <IconButton
              onClick={handleSave}
              disabled={!userPermissions.manageReviewers}
              title="Save"
            >
              <SaveOutlined />
            </IconButton>
          </>
        ) : (
          <>
            {stageName === "" ? "Approval Stage" : stageName}
            {userPermissions.manageReviewers && (
              <IconButton onClick={toggleEditMode} title="Edit">
                <EditOutlinedIcon />
              </IconButton>
            )}
          </>
        )}
      </InlineEditWrapper>
    </Grid>
  );
};
